import React from 'react';
import { useTranslation } from 'react-i18next';
import { KoobButton } from '@koob/ui';
import { formatDate } from '@koob/dates';
import type { FolderArchiveInfo } from './types/folderActions';

export interface FolderArchivedBannerProps {
  folder: FolderArchiveInfo;
  /** Hidden when the app does not let this user unarchive. */
  onUnarchive?: () => void;
}

/** KD-3842: grey banner on an archived client folder. */
export default function FolderArchivedBanner({
  folder,
  onUnarchive,
}: FolderArchivedBannerProps) {
  const { t } = useTranslation('folders');
  const author = folder?.archivedBy
    ? `${folder.archivedBy.firstName ?? ''} ${
        folder.archivedBy.lastName ?? ''
      }`.trim()
    : '';

  return (
    <div
      className="flex flex-wrap items-center justify-between gap-3 border-0 border-b border-solid border-gray-200 bg-gray-100 px-6 py-3 text-sm text-gray-700"
      data-testid="folder-archived-banner"
    >
      <span className="inline-flex items-center gap-2">
        <i className="fa-regular fa-box-archive" aria-hidden="true" />
        {t('archive.banner', {
          date: formatDate(folder?.archivedAt, 'DD/MM/YYYY'),
          author: author || '--',
        })}
      </span>
      {onUnarchive && (
        <KoobButton
          variant="secondary"
          size="sm"
          onClick={onUnarchive}
          data-testid="folder-archived-banner-unarchive"
        >
          <i className="fa-regular fa-box-open" aria-hidden="true" />
          {t('actions.unarchive')}
        </KoobButton>
      )}
    </div>
  );
}
